const DEFAULT_MOBILE_STEPPER_CLASS_NAME = 'default-mobile-stepper';
export default DEFAULT_MOBILE_STEPPER_CLASS_NAME;
